import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import modules from "./modules";
Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "my-app",
  storage: window.localStorage,
  modules: []
});

export default new Vuex.Store({
  modules,
  plugins: [vuexPersist.plugin],
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/store/index.js